import { toastHandler } from '@/components/utils/Toast'

type CustomError = {
    data?: {
        error?: string | { location: string; msg: string; path: string }[]
        message?: string
    }
}

/** Axios error.response or full Axios error (when response is undefined for network errors) */
const handleResponseError = (errorOrResponse: CustomError | undefined, axiosError?: { message?: string }) => {
    const data = errorOrResponse?.data
    if (data) {
        const errors = data.error
        const message = data.message

        if (message) {
            toastHandler({ message, state: 'error' })
            return
        }

        if (typeof errors === 'string' && errors.trim()) {
            toastHandler({ message: errors, state: 'error' })
            return
        }

        if (errors && Array.isArray(errors) && errors.length > 0) {
            toastHandler({ message: errors[0].msg, state: 'error' })
            return
        }
    }

    // No response (network error, timeout, CORS) — show generic message
    const fallback = axiosError?.message || 'Request failed. Please check your connection and try again.'
    toastHandler({ message: fallback, state: 'error' })
}

export default handleResponseError
